import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ask-a-person',
  templateUrl: './ask-a-person.component.html',
  styleUrls: ['./ask-a-person.component.css'],
})
export class AskAPersonComponent implements OnInit {
  selected: string = 'ask-a-person';
  loading: boolean = true;
  records: any[] = [];

  // Pagination
  page: number = 1;
  pageSize: number = 10;
  collectionSize: number = 0;
  pageSizeOptions = [10, 20, 50, 100];

  // Delete confirmation modal
  showDeleteModal: boolean = false;
  deleteRecordId: number = 0;
  deleting: boolean = false;
  deleteSuccessMessage: string = '';

  // Note modal
  showNoteModal: boolean = false;
  noteRecordId: number = 0;
  noteText: string = '';
  savingNote: boolean = false;

  private apiBase = `${environment.apiConfig.uri}/api/Chatbot`;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.loading = true;
    const params = {
      pageNumber: this.page.toString(),
      pageSize: this.pageSize.toString()
    };

    this.http.get(`${this.apiBase}/GetAskPerson`, { params }).subscribe({
      next: (response: any) => {
        if (response?.data?.records) {
          this.records = response.data.records;
          this.collectionSize = response.data.totalRecords;
        } else if (Array.isArray(response?.data)) {
          this.records = response.data;
          this.collectionSize = response.data.length;
        } else {
          this.records = [];
          this.collectionSize = 0;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading questions:', err);
        this.records = [];
        this.loading = false;
      }
    });
  }

  onPageChange(newPage: number) {
    this.page = newPage;
    this.loadData();
  }

  onPageSizeChange(newPageSize: number) {
    this.pageSize = newPageSize;
    this.page = 1;
    this.loadData();
  }

  onStatusChange(record: any) {
    const params = {
      id: record.id.toString(),
      status: record.status
    };

    this.http.patch(`${this.apiBase}/UpdateAskPersonStatus`, null, { params }).subscribe({
      next: () => {},
      error: (err) => {
        console.error('Error updating status:', err);
      }
    });
  }

  deleteRecord(id: number) {
    this.deleteRecordId = id;
    this.deleteSuccessMessage = '';
    this.showDeleteModal = true;
  }

  confirmDelete() {
    this.deleting = true;
    this.http.get(`${this.apiBase}/DeleteAskPerson`, { params: { id: this.deleteRecordId.toString() } }).subscribe({
      next: () => {
        this.deleting = false;
        this.deleteSuccessMessage = 'Record deleted successfully.';
        this.loadData();
      },
      error: (err) => {
        console.error('Error deleting record:', err);
        this.deleting = false;
        this.showDeleteModal = false;
      }
    });
  }

  closeDeleteModal() {
    this.showDeleteModal = false;
    this.deleteRecordId = 0;
    this.deleteSuccessMessage = '';
  }

  openNoteModal(record: any) {
    this.noteRecordId = record.id;
    this.noteText = record.note || '';
    this.showNoteModal = true;
  }

  closeNoteModal() {
    this.showNoteModal = false;
    this.noteRecordId = 0;
    this.noteText = '';
  }

  saveNote() {
    this.savingNote = true;

    this.http.patch(
      `${this.apiBase}/UpdateAskPersonNote`,
      JSON.stringify(this.noteText),
      {
        params: { id: this.noteRecordId.toString() },
        headers: { 'Content-Type': 'application/json' }
      }
    ).subscribe({
      next: () => {
        this.savingNote = false;
        const record = this.records.find(r => r.id === this.noteRecordId);
        if (record) record.note = this.noteText;
        this.closeNoteModal();
      },
      error: (err) => {
        console.error('Error saving note:', err);
        this.savingNote = false;
      }
    });
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(-2);
    return `${day}.${month}.${year}`;
  }
}
